var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        [
          _vm.applicationLinks.length > 0
            ? [
                _c(
                  "nav",
                  {
                    staticClass: "navbar navbar-sidebar application-bar",
                    style: { width: `${_vm.applicationBarWidth}px` },
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "navbar-nav" },
                      [
                        _vm._l(_vm.applicationLinks, function (link, index) {
                          return [
                            link.type == "SPACER"
                              ? _c("li", {
                                  key: `applnk.${index}`,
                                  staticClass: "nav-item mt-auto",
                                })
                              : _c(
                                  "li",
                                  {
                                    key: `applnk.${index}`,
                                    staticClass: "nav-item",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: _vm.$t(link.label),
                                              trigger: _vm.expanded
                                                ? "none"
                                                : "hover",
                                              placement: "right",
                                              classes: link.isCurrent
                                                ? "active"
                                                : "",
                                            },
                                            expression:
                                              "{\n                                content: $t(link.label),\n                                trigger: expanded ? 'none' : 'hover',\n                                placement: 'right',\n                                classes: link.isCurrent ? 'active' : '',\n                            }",
                                          },
                                        ],
                                        staticClass: "nav-link",
                                        class: { active: link.isCurrent },
                                        attrs: {
                                          href: link.url,
                                          "data-toggle": "collapse",
                                          "data-target":
                                            ".navbar-collapse.show",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon" },
                                          [
                                            link.icon &&
                                            link.icon.type == "custom"
                                              ? [
                                                  _c("Icon", {
                                                    attrs: {
                                                      name: link.icon.name,
                                                      width: 30,
                                                      height: 30,
                                                      isOutlined: link.isCurrent
                                                        ? false
                                                        : true,
                                                    },
                                                  }),
                                                ]
                                              : link.icon
                                              ? [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: [
                                                        link.icon.type,
                                                        link.icon.name,
                                                      ],
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v(_vm._s(_vm.$t(link.title))),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "nav",
            {
              staticClass: "navbar navbar-sidebar",
              class: { "is-expanded": _vm.expanded },
              style: {
                width: `${
                  _vm.expanded ? _vm.sidebarWidthExpanded : _vm.sidebarWidth
                }px`,
                left: `${_vm.applicationBarWidth}px`,
              },
            },
            [
              _c(
                "div",
                { staticClass: "brand-container" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "brand",
                      style: _vm.homePageNavigation
                        ? { cursor: "pointer" }
                        : {},
                      on: { click: _vm.handleBrandClick },
                    },
                    [
                      !!this.$slots.logo
                        ? [_vm._t("logo")]
                        : [_c("img", { attrs: { src: _vm.imageUri } })],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.expanded && !!this.$slots.collapsedLogo
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "brand-collapsed pointer",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleCollapsedClick.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_vm._t("collapsedLogo")],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCollapse
                    ? [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.expanded
                                  ? null
                                  : {
                                      content: _vm.$t("expand"),
                                      trigger: "hover",
                                      placement: "right",
                                    },
                                expression:
                                  "\n                        expanded\n                            ? null\n                            : {\n                                  content: $t('expand'),\n                                  trigger: 'hover',\n                                  placement: 'right',\n                              }\n                    ",
                              },
                            ],
                            staticClass: "btn-expand",
                            attrs: { href: "" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onToggle.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "icon" },
                              [
                                _vm.expanded
                                  ? _c("Icon", {
                                      attrs: {
                                        name: "Collapse",
                                        width: 11,
                                        height: 11,
                                      },
                                    })
                                  : _c("Icon", {
                                      attrs: {
                                        name: "Expand",
                                        width: 11,
                                        height: 11,
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "navbar-nav" },
                [
                  _vm._l(_vm.links, function (link) {
                    return [
                      link.type == "HEADER"
                        ? _c(
                            "li",
                            { key: "head_" + link.id, staticClass: "header" },
                            [_c("span", [_vm._v(_vm._s(_vm.$t(link.title)))])]
                          )
                        : link.type == "SPACER"
                        ? [
                            !!_vm.$slots.sidebarExpanded && _vm.expanded
                              ? [
                                  _c(
                                    "li",
                                    { staticClass: "nav-item" },
                                    [_vm._t("sidebarExpanded")],
                                    2
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", {
                              key: link.id,
                              staticClass: "nav-item mt-auto",
                            }),
                          ]
                        : _c("li", { key: link.id, staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.expanded
                                      ? null
                                      : {
                                          content: _vm.$t(link.title),
                                          trigger: "hover",
                                          placement: "right",
                                          classes: link.isActive
                                            ? "active"
                                            : "",
                                        },
                                    expression:
                                      "\n                            expanded\n                                ? null\n                                : {\n                                      content: $t(link.title),\n                                      trigger: 'hover',\n                                      placement: 'right',\n                                      classes: link.isActive ? 'active' : '',\n                                  }\n                        ",
                                  },
                                ],
                                staticClass: "nav-link",
                                class: { active: link.isActive },
                                attrs: {
                                  href: "",
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.goto(link.url)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "icon" },
                                  [
                                    link.icon && link.icon.type == "custom"
                                      ? [
                                          _c("Icon", {
                                            attrs: { name: link.icon.name },
                                          }),
                                        ]
                                      : link.icon
                                      ? [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: [
                                                link.icon.type,
                                                link.icon.name,
                                              ],
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t(link.title))),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-auto" }),
              _vm._v(" "),
              _vm.expanded
                ? [
                    _vm._t("bottomExpanded"),
                    _vm._v(" "),
                    _vm.user && _vm.user.profile
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "profile",
                              attrs: { href: `${_vm.adminUri}` },
                            },
                            [
                              _c("avatar", {
                                staticClass: "xl",
                                attrs: {
                                  url: _vm.user.profile.avatarUrl,
                                  firstName: _vm.user.profile.firstName,
                                  lastName: _vm.user.profile.lastName,
                                  hideName: true,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "tag mt15-xs mb5-xs" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.user.profile.tenantDisplayName) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.user.profile.firstName) +
                                    "\n                        " +
                                    _vm._s(_vm.user.profile.lastName) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "email" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.user.profile.email) +
                                    "\n                    "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "signout",
                              attrs: { to: "/signout" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("Signout")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "copy-footer" },
                      [
                        _c("span", { staticClass: "version" }, [
                          _vm._v(_vm._s(_vm.version)),
                        ]),
                        _vm._v(" "),
                        _vm.termsUrl
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "terms txt",
                                  attrs: {
                                    href: _vm.termsUrl,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("termsAndConditions")))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : [
                    _vm.user && _vm.user.profile
                      ? [
                          _c(
                            "div",
                            { staticClass: "w100 d-flex h-center mb15-xs" },
                            [
                              _c("ul", { staticClass: "navbar-nav" }, [
                                _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link avatar",
                                      attrs: { href: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onToggle.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon" },
                                        [
                                          _c("avatar", {
                                            staticClass: "m0",
                                            attrs: {
                                              url: _vm.user.profile.avatarUrl,
                                              firstName:
                                                _vm.user.profile.firstName,
                                              lastName:
                                                _vm.user.profile.lastName,
                                              hideName: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }